/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import './menu-popup.css';
import { useNavigate } from 'react-router-dom';
import MenuOptionItem from '../menuOptionItem/MenuOptionItem';
import Checkbox from '../checkbox/Checkbox';
import Modal from '../modal/Modal';

export default function MenuPopup(props) {
    const {
        page,
        logout,
        switchModalShow,
        setSwitchModalShow,
        agencyList,
        assetDetails,
        rowData,
        editButton,
        enabledDisabledButton,
        deleteButton,
        handleSwitchModal,
        agencyRow,
        policiesStatus,
        markAsRead,
        liveMapNav,
        insightsNav,
        maintenanceNav = () => {},
        selectedCheckboxes,
        checkboxStates,
        handleToggle,
        handleSelectAll,
        isAllSelected,
    } = props;
    const navigate = useNavigate();
    const [optionDisabled, setOptionDisabled] = useState(true);

    const stateChange = () => {
        if (agencyList.length !== 1) {
            setSwitchModalShow(!switchModalShow);
        }
    };

    const configurationsNavigate = () => {
        navigate('/inventory/assetdevices/configuration', { replace: true, state: assetDetails });
    };

    const configurationsNavigate2 = () => {
        navigate('/inventory/batteryConfigurator/addBatteryConfig', { replace: true, state: assetDetails });
    };

    const configurationsNavigateFuel = () => {
        if (!assetDetails) return;
        navigate('/inventory/fuelconfigurator/addFuelConfig', { replace: true, state: assetDetails });
    };

    const configurationsNavigateVehicle = () => {
        if (!assetDetails) return;
        const { onDelete, ...presetState } = assetDetails;
        navigate('/inventory/vehicleconfigurator/addVehicleConfig', {
            replace: true,
            state: {
                ...presetState,
                id: presetState.id || presetState.oid,
            },
        });
    };

    const agenciesConfigurationNavigate = () => {
        navigate('/agencies/Configurations/General', { replace: true, state: agencyRow });
    };

    const navigationBody = (value) => {
        switch (value) {
            case 'footerNavigationMobile':
                return (
                    <>
                        <MenuOptionItem label="Switch Agency Workspace" menuButtonClicked={stateChange} disable={agencyList.length === 1} />
                        <MenuOptionItem label="Log out" menuButtonClicked={logout} />
                    </>
                );
            case 'footerNavigation':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Switch Agency Workspace" menuButtonClicked={stateChange} disable={agencyList.length === 1} bottomBorder />
                        <MenuOptionItem label="Log out" menuButtonClicked={logout} bottomBorder />
                    </div>
                );
            case 'assetsAndDevices':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Configurations" menuButtonClicked={configurationsNavigate} bottomBorder />
                        <MenuOptionItem label="Live Map Overview" menuButtonClicked={liveMapNav} />
                        <MenuOptionItem label="Telemetry Logs" menuButtonClicked={insightsNav} />
                        <MenuOptionItem label="Maintenance Module" menuButtonClicked={maintenanceNav} />
                    </div>
                );
            case 'adminAssetAndDevices':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Configurations" menuButtonClicked={configurationsNavigate} bottomBorder />
                    </div>
                );
            case 'adminBatteryConfigurator':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Configurations" menuButtonClicked={configurationsNavigate2} bottomBorder />
                    </div>
                );
            case 'adminFuelConfigurator':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Configurations" menuButtonClicked={configurationsNavigateFuel} bottomBorder />
                    </div>
                );
            case 'adminVehicleConfigurator':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Edit" menuButtonClicked={configurationsNavigateVehicle} bottomBorder={false} />
                        <MenuOptionItem label="Delete" menuButtonClicked={deleteButton} bottomBorder />
                    </div>
                );
            case 'geofence':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Edit" menuButtonClicked={editButton} bottomBorder={false} />
                        {
                            rowData.isEnabled ? <MenuOptionItem label="Disable Policy" menuButtonClicked={policiesStatus} bottomBorder /> : <MenuOptionItem label="Enable Policy" menuButtonClicked={policiesStatus} bottomBorder />
                        }
                        <MenuOptionItem label="Delete" menuButtonClicked={deleteButton} bottomBorder />
                    </div>
                );
            case 'notificationConfiguration':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Edit" menuButtonClicked={editButton} bottomBorder={false} />
                        {
                            rowData.isEnabled ? <MenuOptionItem label="Disable Alert" menuButtonClicked={policiesStatus} bottomBorder /> : <MenuOptionItem label="Enable Alert" menuButtonClicked={policiesStatus} bottomBorder />
                        }
                        <MenuOptionItem label="Delete" menuButtonClicked={deleteButton} bottomBorder />
                    </div>
                );
            case 'automatedReports':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Edit" menuButtonClicked={editButton} bottomBorder />
                        <MenuOptionItem label="Delete" menuButtonClicked={deleteButton} bottomBorder={false} />
                    </div>
                );
            case 'security':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Log out of all devices" menuButtonClicked={handleSwitchModal} bottomBorder />
                    </div>
                );
            case 'agencies':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Configurations" menuButtonClicked={agenciesConfigurationNavigate} bottomBorder />
                        <MenuOptionItem label="Live Map Overview" menuButtonClicked={() => { }} bottomBorder={false} />
                        <MenuOptionItem label="Telemetry Logs" menuButtonClicked={() => { }} bottomBorder />
                    </div>
                );
            case 'connectivity':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label="Configurations" menuButtonClicked={() => { }} bottomBorder={false} />
                    </div>
                );
            case 'notifications':
                return (
                    <div className="menupopup-container">
                        <MenuOptionItem label={Object.values(selectedCheckboxes).every((v) => v === false) ? 'Mark all as read' : 'Mark as read'} menuButtonClicked={markAsRead} bottomBorder />
                    </div>
                );
            case 'notifications-filter':
                return (
                    <div className="menupopup-container" style={{ maxHeight: '350px', overflowY: 'auto', minWidth: '280px' }}>
                        {/* Select All Option */}
                        <div
                          className="menupopup-item-container"
                          style={{
                            borderBottom: '1px solid #EAECF0', marginBottom: '0.5rem', paddingBottom: '0.5rem', position: 'sticky', top: '0', backgroundColor: '#FFFFFF', zIndex: 1, padding: '0.75rem 1rem',
                            }}
                        >
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={isAllSelected()}
                                  indeterminate={!isAllSelected() && Object.values(checkboxStates).some((state) => state === true)}
                                  onChange={handleSelectAll}
                                  inputProps={{ 'aria-label': 'Select All Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text" style={{ fontWeight: '800' }}>
                                    Select All
                                </div>
                            </div>
                        </div>

                        {/* Geofence Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.geofence}
                                  onChange={() => handleToggle('geofence')}
                                  inputProps={{ 'aria-label': 'Geofence Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    Geofence
                                </div>
                            </div>
                        </div>

                        {/* Unplugged Status Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.unplugged}
                                  onChange={() => handleToggle('unplugged')}
                                  inputProps={{ 'aria-label': 'Unplugged Status Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    Unplugged Status
                                </div>
                            </div>
                        </div>

                        {/* Asset Status Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.assetStatus}
                                  onChange={() => handleToggle('assetStatus')}
                                  inputProps={{ 'aria-label': 'Asset Status Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    Asset Status
                                </div>
                            </div>
                        </div>

                        {/* Speeding Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.speeding}
                                  onChange={() => handleToggle('speeding')}
                                  inputProps={{ 'aria-label': 'Speeding Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    Speeding Alert
                                </div>
                            </div>
                        </div>

                        {/* Battery Status Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.batteryStatus}
                                  onChange={() => handleToggle('batteryStatus')}
                                  inputProps={{ 'aria-label': 'Battery Status Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    Battery Status
                                </div>
                            </div>
                        </div>

                        {/* EV Range Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.evRange}
                                  onChange={() => handleToggle('evRange')}
                                  inputProps={{ 'aria-label': 'EV Range Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    EV Range
                                </div>
                            </div>
                        </div>

                        {/* EV Charging Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.evCharging}
                                  onChange={() => handleToggle('evCharging')}
                                  inputProps={{ 'aria-label': 'EV Charging Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    EV Charging
                                </div>
                            </div>
                        </div>

                        {/* EV Battery Temperature Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.evBatteryTemperature}
                                  onChange={() => handleToggle('evBatteryTemperature')}
                                  inputProps={{ 'aria-label': 'EV Battery Temperature Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    EV Battery Temperature
                                </div>
                            </div>
                        </div>

                        {/* EV Battery SoH Alerts */}
                        <div className="menupopup-item-container">
                            <div className="nav-justify-menupopup">
                                <Checkbox
                                  checked={checkboxStates.evBatteySoH}
                                  onChange={() => handleToggle('evBatteySoH')}
                                  inputProps={{ 'aria-label': 'EV Battery SoH Alerts' }}
                                  style={{ width: '20px', height: '20px' }}
                                />
                                <div className="menupopup-text">
                                    EV Battery State of Health
                                </div>
                            </div>
                        </div>
                    </div>
                ); default:
                return null;
        }
    };
    return (
        <>
            {navigationBody(page)}
        </>
    );
}
